import { songs } from "../database/song";
import {
  CHANGETRACK,
  PLAYPAUSE,
  PLAYPAUSEPLAYLIST,
  SEARCHTEXT,
} from "../actions";

const INITIAL_STATE = {
  songData: {
    _id: 10000001,
    title: "Saami Saami",
    thumbnail: require("../assets/songs_thumb/saamisaamithumb.jpeg"),
    singer: "Devi Sri Prasad",
    song: require("../database/audio_songs/Pushpa_ Saami Saami - Lyrical (Hindi) _ Allu Arjun, Rashmika Mandanna _ Sunidhi C _ DSP _ Sukumar.mp3"),
  },
  isPlaying: true,
  searchText: "",
  isPlayListPlaying: true,
  playListId: "",
};

export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PLAYPAUSE:
      return {
        ...state,
        isPlaying: action.payload,
      };
    case PLAYPAUSEPLAYLIST:
      return {
        ...state,
        isPlayListPlaying: action.payload,
        playListId: action.payloadPlayListId,
      };
    case SEARCHTEXT:
      return {
        ...state,
        searchText: action.searchSong,
      };
    case CHANGETRACK:
      return {
        ...state,
        songData: {
          ...state.songData,
          _id: action.payload,
          title: songs.find((song) => song._id == action.payload).title,
          thumbnail: songs.find((song) => song._id == action.payload).thumbnail,
          singer: songs.find((song) => song._id == action.payload).singer,
          song: songs.find((song) => song._id == action.payload).song,
        },
      };
    default:
      return state;
  }
};
